import { Component, OnInit, ViewChild } from '@angular/core';
import { Validators, FormBuilder } from '@angular/forms';
import { GooglePlaceDirective } from 'ngx-google-places-autocomplete';
import { DataService } from 'src/app/Service/data.service';
import { MainService } from 'src/app/Service/main.service';

@Component({
  selector: 'app-report-request',
  templateUrl: './report-request.component.html',
  styleUrls: ['./report-request.component.scss']
})
export class ReportRequestComponent implements OnInit {

  @ViewChild('placesRef') placesRef: GooglePlaceDirective;

  ReportRequestForm = this.fb.group({
    email: ['', [Validators.required, Validators.email, Validators.pattern(/^(\d{10}|\w+@\w+\.\w{2,3})$/)]],
    password: ['', [Validators.required]],
    name: ['', [Validators.required]],
    SSN: ['', [Validators.required]],
    DOB: ['', [Validators.required]],
    streetAddress: ['', [Validators.required]],
    city: ['', [Validators.required]],
    state: ['', [Validators.required]],
    zipcode: ['', [Validators.required]],
    LCIJInput: ['', [Validators.required]],
    uploadedDocuments: ['', [Validators.required]],
    document: ['', [Validators.required]]

  });
  response: any = {};

  constructor(private fb: FormBuilder,
              private mainService: MainService,
              private DataServiceObj: DataService) { }

  ngOnInit(): void {
  }

  get f() {
    return this.ReportRequestForm.controls;
  }

  public handleAddressChange(address: any) {
    const add = address.formatted_address;
    const value = add.split(',');
    const state = value[2].split(' ');

    this.ReportRequestForm.patchValue({
      city: value[1],
      state: state[1],
      zipcode: state[2]
    });
  }
  submit() {
    console.log(this.ReportRequestForm.value);
    const token = this.DataServiceObj.getUserToken();
    this.DataServiceObj.addUpdateQualityAssurence('admin/requestReport/createRequest', this.ReportRequestForm.value, token).subscribe(res => {
      this.response = res;
      if (this.response.Status = 200) {

        this.mainService.ShowAlert('Report requested Successfully', this.response.Message);
        this.ReportRequestForm.reset();
      } else {
      }
    },
      err => {

      });
  }

  onFileChange(event) {
    const reader = new FileReader();

    if (event.target.files && event.target.files.length) {
      console.log(event.target.files[0]);
      this.ReportRequestForm.patchValue({ document: event.target.files[0] });
      this.onDocumentUpload();
      // reader.readAsDataURL(file);
      // reader.onload = () => {
      //   this.ReportRequestForm.patchValue({
      //     document: reader.result
      //   });
      //   // need to run CD since file load runs outside of zone
      //   this.cd.markForCheck();
      // };
    }
  }

  onDocumentUpload() {
    //  alert("came")
    const userToken = this.DataServiceObj.getUserToken();
    const formData = new FormData();
    formData.append('file', this.ReportRequestForm.get('document').value);

    this.DataServiceObj.uploadFile('admin/requestReport/uploadDocumentsForRequestReport', formData, userToken).subscribe((result) => {
      this.response = result;
      if (this.response.Status == 200) {
        console.log(this.ReportRequestForm.value);
        //   this.ReportRequestForm.patchValue({ document_id: event.target.files[0] })
        this.mainService.ShowAlert('Success', 'Document uploaded successfully');

      } else {
        this.mainService.ShowAlert('Error', 'Error while uploading document');
      }
    }, (error) => {
      this.mainService.ShowAlert('Error', 'Something went wrong. Please try after sometime.');
    });
  }

}
